<template>
    <div class="card shadow mb-4">    
        <div class="card-header py-3">
            <div class="row">
                <h4 class="m-0 font-weight-bold text-primary mb-2">Steps Sequences for Category {{category.title}}</h4>
                <button @click="AddNewSequence()" type="button" class="btn btn-primary ml-auto mr-3 mb-3">Add New Sequence</button >
            </div>
        </div>
        <div v-if="response.success != null || response.updateSuccess != null" v-bind:class="{ 'alert-success': response.success || response.updateSuccess, 'alert-danger': !(response.success || response.updateSuccess)}" class="alert" role="alert">
            {{response.message}} 
        </div>
        <div class="card-body">
            <b-table 
                show-empty
                striped
                :items="stepSequences"
                :fields="fields">
                <template v-slot:cell(previous-step)="row">
                    <b-form-select v-model="row.item.previousStepId" >
                        <option v-for="(categoryStep, index) in categorySteps" :key="index" :value="categoryStep.id">{{categoryStep.title}}</option>
                    </b-form-select>
                </template>
                <template v-slot:cell(next-step)="row">
                    <b-form-select v-model="row.item.nextStepId" >
                        <option v-for="(categoryStep, index) in categorySteps" :key="index" :value="categoryStep.id">{{categoryStep.title}}</option>
                    </b-form-select>
                </template>
                <template v-slot:cell(minimum-score)="row">
                    <b-form-input type="number" v-model="row.item.minimumScore" placeholder="Enter minimum score"></b-form-input>
                </template>
                <template v-slot:cell(maximum-score)="row">
                    <b-form-input type="number" v-model="row.item.maximumScore" placeholder="Enter maximum score"></b-form-input>
                </template>
                <template v-slot:cell(delete)="row">
                    <button @click="enableDeleteModal(row)" class="btn btn-danger">Delete</button >
                </template>
            </b-table>
            
        </div>
        
        <button @click="updateCategoryStepSequences()" type="button" class="btn btn-primary ml-auto mr-3 mb-3">Update</button >
    
        <modal :title="modalTitle" :body="modalBody" :button="modalButtonText" @action="deleteCategoryStepSequence(modalCategoryStepSequenceId)" v-if="showModal" @close="showModal = false"></modal>
    </div>
</template>

<script>
import Modal from './../../misc/Modal.vue';
export default {
    components: {
            modal: Modal
    },
    data() {
        return {
            //categorySteps: [],
            category: {},
            stepSequences: [],
            fields: [
                { key: 'previous-step', label: 'Previous Step', sortable: true },
                { key: 'next-step', label: 'Next Step' },
                { key: 'minimum-score', label: 'Minimum Score', tdClass: 'w-100px'},
                { key: 'maximum-score', label: 'Maximum Score', tdClass: 'w-100px'},
                { key: 'delete', label: 'Delete', tdClass: 'fit' }
            ],
            response: {},
            modalCategoryStepSequenceId: null,
            modalBody: null,
            modalTitle: "Delete Confirmation",
            modalButtonText: "Delete",
            showModal: false,
        }
    },
    computed:{
        categoryId: function(){
            return this.$route.params.categoryId;
        },
        categorySteps: function(){
            return this.category.steps;
        }
    },
    methods :{
        loadCategorySteps: function() {
            let self = this;
            this.$http.get('/api/categories/get-with-steps/' + this.$route.params.categoryId)
            .then(response => {
                self.category = response.data;
                self.loadCategoryStepSequences();
            })
            .catch(error => {
                console.log(error);
                $router.push('/404');
            })
        },
        loadCategoryStepSequences: function() {
            let self = this;
            this.$http.get('/api/category-steps/sequences/get-per-category/' + this.categoryId)
            .then(response => {
                self.stepSequences = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        updateCategoryStepSequences: function()
        {
            let self = this;
            this.$http.put('/api/category-steps/sequences/update-per-category/' + this.categoryId, this.stepSequences)
            .then(response => {
                console.log(response.data);
                self.response = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        enableDeleteModal: function(row){
            this.modalBody = `Select 'Delete' below if you are sure you want to delete the Category Step Sequence`;
            if(row.item.id)
                this.modalCategoryStepSequenceId = row.item.id;
            else
                this.modalCategoryStepSequenceId = row.index;
            this.showModal = true;
        },
        deleteCategoryStepSequence: function(categoryStepSequenceId) {
            if(categoryStepSequenceId.toString().includes('-'))
            {
                let self = this;
                this.$http.delete(`/api/category-steps/sequences/${categoryStepSequenceId}/delete/`)
                .then(response => {
                    var localDeleteResponse = response.data;
                    localDeleteResponse.id = categoryStepSequenceId;
                    self.response = localDeleteResponse;
                })
                .catch(error => {
                    console.log(error);
                })
            }
            else
            {
                this.stepSequences.splice(categoryStepSequenceId, 1);
            }
        },
        AddNewSequence: function()
        {
            var newSequence = {
                "previousStepId":"",
                "nextStepId":"",
                "maximumScore": '',
                "minimumScore": ''
            }
            this.stepSequences.push(newSequence);
        },
        deleteAddedEntry: function(index)
        {
            this.stepSequences.splice(index, 1);
        }
    },
    mounted: function() {
        this.loadCategorySteps();
    },
    watch:
    {
        response: function(newResponse)
        {
            if(newResponse.success === true)
            {
                // get index of object with id: newResponse.id
                var removeIndex = this.stepSequences.map(function(item) { return item.id; }).indexOf(newResponse.id);
                // remove object
                this.stepSequences.splice(removeIndex, 1);
            }
            else if(newResponse.updateSuccess === true)
            {
                for(let i = 0; i < this.stepSequences.length; i++)
                {
                    if(!this.stepSequences[i].id)
                    {
                        for(let j = 0 ; j < newResponse.stepSequences.length; j++)
                        {
                            if(newResponse.stepSequences[j].previousStepId == this.stepSequences[i].previousStepId
                                && newResponse.stepSequences[j].nextStepId == this.stepSequences[i].nextStepId 
                                && newResponse.stepSequences[j].maximumScore == this.stepSequences[i].maximumScore
                                && newResponse.stepSequences[j].minimumScore == this.stepSequences[i].minimumScore)
                            {
                                this.stepSequences[i].id = newResponse.stepSequences[j].id;
                            }
                        }
                    }
                }
            }
            setTimeout(() => {this.response.success = null; this.response.updateSuccess = null}, 3000)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
